export const getUserId = (userSubjectIdentifier: string): string => {
  return userSubjectIdentifier.replace('prod-rio-users:', '');
};
